document.documentElement.classList.add('js-ready');

const termsModal = document.querySelector('.terms-and-conditions-modal');
const toggleButtons = document.querySelectorAll('.toggle-terms-and-conditions');

if (termsModal && toggleButtons.length) {
  const setModalState = (isOpen) => {
    termsModal.classList.toggle('is-open', isOpen);
    termsModal.setAttribute('aria-hidden', String(!isOpen));
    document.body.classList.toggle('modal-open', isOpen);
  };

  toggleButtons.forEach((button) => {
    button.addEventListener('click', () => {
      setModalState(!termsModal.classList.contains('is-open'));
    });
  });

  termsModal.addEventListener('click', (event) => {
    if (event.target === termsModal) {
      setModalState(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setModalState(false);
    }
  });
}
